import { Target } from '../target/target.model';

export class CreateTargetResponse {
    createTarget: String;

    constructor(targetCreated: string){
        this.createTarget=targetCreated;
    }
}
